import Vue from 'vue';
import Vuex from 'vuex';
import Router from '@/router';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    screenWidth:document.documentElement.clientWidth, //屏幕宽度
    // screenHeight:document.documentElement.clientHeight, //屏幕高度

    userInfo: LocalStorage.getTime(LOCAL_KEY_USER_INFO), // 用户信息
  },
  mutations: {
    setScreenWidth(state, newVal) {
      state.screenWidth = newVal;
    },
    // setScreenHeight(state, newVal) {
    //   state.screenHeight = newVal;
    // },
    login(state, data) {
      LocalStorage.setTime(LOCAL_KEY_USER_INFO, data.userInfo);
      state.userInfo = data.userInfo;
      Router.push({ path: data.redirectUrl ? data.redirectUrl : '/home' });
      // Router.back();
    },
    loginOut(state) {
      LocalStorage.remove(LOCAL_KEY_USER_INFO);
      state.userInfo = '';
      Router.push({ path: '/login' });
    },
    refreshUser(state){
      state.userInfo = LocalStorage.getTime(LOCAL_KEY_USER_INFO);
    },
    refreshPage(state){
      Router.push({ path: '/login' });
    }
  },
  actions: {
  },
  modules: {
  }
})
